import { render, staticRenderFns } from "./InfiniteScroll.vue?vue&type=template&id=8c54cc60&scoped=true&"
import script from "./InfiniteScroll.vue?vue&type=script&lang=ts&"
export * from "./InfiniteScroll.vue?vue&type=script&lang=ts&"
import style0 from "./InfiniteScroll.vue?vue&type=style&index=0&id=8c54cc60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c54cc60",
  null
  
)

export default component.exports